import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

import { getSelectionAll } from '../api';

type Props = {
  enabled?: boolean;
  selectionId: string | null;
};

export const LIVE_SELECTION_DATA_QUERY_KEY_BASE = 'read-live-selection-all';

export const useLiveSelectionData = ({ enabled = true, selectionId }: Props) => {
  const queryClient = useQueryClient();
  const queryKey = useMemo(() => [LIVE_SELECTION_DATA_QUERY_KEY_BASE, selectionId], [selectionId]);

  const {
    data: selectionData,
    isInitialLoading,
    error: selectionDataError,
  } = useQuery(queryKey, () => getSelectionAll(selectionId!, false), {
    enabled: !!enabled && !!selectionId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const resetLiveSelectionQuery = useCallback(() => {
    queryClient.resetQueries({ queryKey });
  }, [queryClient, queryKey]);

  return {
    resetLiveSelectionQuery,
    selectionData,
    selectionDataLoading: isInitialLoading,
    selectionDataError,
  };
};
